import { SourceSyncStatus, SourceType } from "@gx/ts-contracts/services/database/models/public_pb";

import { EditSourceDrawerTab } from "@/pages/sources/components/edit/types";

export const EDIT_SOURCE_FORM_INPUT_WIDTH: number = 600;
export const EDIT_SOURCE_FORM_ADVANCED_CONFIGURATION_INPUT_WIDTH: number = 560;

export const EDIT_SOURCE_DRAWER_TAB_LABELS: Record<EditSourceDrawerTab, string> = {
  [EditSourceDrawerTab.OVERVIEW]: "Overview",
  [EditSourceDrawerTab.CONTENT]: "Content",
  [EditSourceDrawerTab.ARTIFACTS]: "Artifacts",
  [EditSourceDrawerTab.SYNCS]: "Syncs",
  [EditSourceDrawerTab.SETTINGS]: "Settings",
};

export const SYNC_STATUS_TO_BUTTON_DISABLED_MAP: Record<SourceSyncStatus, boolean> = {
  [SourceSyncStatus.UNSPECIFIED]: false,
  [SourceSyncStatus.START]: true,
  [SourceSyncStatus.RUNNING]: true,
  [SourceSyncStatus.START_FAILED]: false,
  [SourceSyncStatus.NORMALIZE]: true,
  [SourceSyncStatus.NORMALIZE_FAILED]: false,
  [SourceSyncStatus.EXTRACT]: true,
  [SourceSyncStatus.EXTRACT_FAILED]: false,
  [SourceSyncStatus.LOAD]: true,
  [SourceSyncStatus.LOAD_FAILED]: false,
  [SourceSyncStatus.RESEARCH]: true,
  [SourceSyncStatus.RESEARCH_FAILED]: false,
  [SourceSyncStatus.COMPLETE]: false,
  [SourceSyncStatus.FAILED]: false,
};

export const RESYNCABLE_SOURCE_TYPES: SourceType[] = [
  SourceType.WIKIPEDIA,
  SourceType.BROWSERBASE,
  SourceType.FILE_UPLOAD,
  SourceType.TEXT,
];
